import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import styled from 'styled-components'
import { Link } from 'gatsby'

import ItemizedReviewList from '../../../organisms/ItemizedReviewList'
import RecommendList from '../../../organisms/RecommendList'
import { MysqlProducts, MysqlRanks, MysqlRanksEdge, MysqlSurveyQuestionsEdge } from '../../../graphqlTypes'

const Container = styled.li`
  margin: 26px 0 0;
  padding: 0 7px;
  width: calc(100% / 3);
  &:first-child {
    border-bottom: 1px solid ${({ theme }) => theme.palette.border.light};
    margin: 0;
    padding: 0 0 40px;
    width: 100%;
  }
`

const ProductInfoContainer = styled.div<{ first: number | null }>`
  color: ${({ theme }) => theme.palette.font.main};
  font-weight: bold;
  margin: ${({ first }) => (first ? '0 0 0 15px' : '12px 0 0')};
`

const Manufacturer = styled.p<{ first: number | null }>`
  color: ${({ theme }) => theme.palette.font.sub};
  font-size: ${({ first }) => (first ? '14px' : '12px')};
  margin: 0 0 4px;
`

const ProductName = styled.p<{ first: number | null }>`
  font-size: ${({ first }) => (first ? '18px' : '14px')};
`

const FirstRankHeading = styled.div`
  align-items: center;
  display: flex;
`

const EmblemImage = styled.img`
  width: 85px;
`

const ProductContainer = styled.div<{ first: number | null }>`
  align-items: flex-start;
  display: ${({ first }) => (first ? 'flex' : 'block')};
  margin: ${({ first }) => (first ? '18px 0 0' : 0)};
`

const ImageFrame = styled(Link)<{ first: number | null }>`
  display: block;
  margin: 0 auto;
  object-fit: contain;
  text-decoration: none;
  width: ${({ first }) => (first ? '320px' : '190px')};
  height: ${({ first }) => (first ? '320px' : '190px')};
`

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`

const ProductReview = styled.div`
  flex: 1;
  margin: 0 0 0 20px;
`

const Label = styled.label`
  color: ${({ theme }) => theme.palette.font.dark};
  display: inline-block;
  margin: 28px 0 7px;
  font-size: 14px;
  font-weight: bold;
`

type Props = {
  rank: MysqlRanks
  ranks: MysqlRanksEdge[]
  surveyQuestions: MysqlSurveyQuestionsEdge[]
}

export default function ListItem({ rank, ranks, surveyQuestions }: Props) {
  const product = rank.products!
  const first = rank.rank === 1 ? 1 : null

  const ProductInfo = () => (
    <ProductInfoContainer first={first}>
      {product.manufacturer && <Manufacturer first={first}>{product.manufacturer}</Manufacturer>}
      <ProductName first={first}>{product.name}</ProductName>
    </ProductInfoContainer>
  )

  return (
    <Container>
      {first && (
        <FirstRankHeading>
          <LazyLoadComponent>
            <EmblemImage
              alt={`${product.name} エンブレム`}
              src={`${product.fields!.emblemImageUrl}?auto=format&w=85&h=85`}
            />
          </LazyLoadComponent>
          <ProductInfo />
        </FirstRankHeading>
      )}
      <ProductContainer first={first}>
        <ImageFrame first={first} to={product.fields!.pagePath!}>
          <LazyLoadComponent>
            <Image
              alt={product.name!}
              src={`${first ? product.fields!.imageUrl! : product.fields!.withEmblemImageUrl!}?auto=format`}
            />
          </LazyLoadComponent>
        </ImageFrame>
        {first && (
          <ProductReview>
            <RecommendList product={product as MysqlProducts} />
            <Label>項目別評価</Label>
            <ItemizedReviewList product={product as MysqlProducts} ranks={ranks} surveyQuestions={surveyQuestions} />
          </ProductReview>
        )}
        {!first && <ProductInfo />}
      </ProductContainer>
    </Container>
  )
}
